export default __webpack_public_path__ + "static/media/successpic.a78bcce5.png";